/* Video cụm "Watch it get built": MỖI LÚC CHỈ MỘT CLIP CHẠY, clip đang lọt vào
 * màn nhiều nhất.
 *
 * VÌ SAO KHÔNG DÙNG THUỘC TÍNH `autoplay`.
 * `autoplay` bảo trình duyệt phát ngay khi dựng xong phần tử, bất kể nó nằm ở
 * đâu trong trang — cụm này ở giữa trang nên khách chưa cuộn tới đã tải cả ba.
 * IntersectionObserver chỉ cho phát khi clip thật sự lọt vào màn.
 *
 * VÌ SAO CHỈ MỘT CLIP, KHÔNG PHẢI CẢ BA. Bản trước cho mọi clip lọt vào màn
 * cùng chạy. Ba luồng video chạy song song luôn tốn gấp ba, và ba khung hình
 * động cạnh nhau cũng không ai xem nổi cùng lúc — khách nhìn được một thứ tại
 * một thời điểm. Hai clip kia đứng ở ảnh poster, vẫn nhận ra là xe gì.
 *
 * 04/09: video đã đổi sang bản web (864x1080, ~2,0 Mbps, 2,2-2,4MB, có
 * faststart) nên gánh nặng băng thông không còn là vấn đề. Giữ luật một-clip vì
 * lý do ĐỌC chứ không phải vì băng thông — đừng bỏ nó đi khi thấy file đã nhẹ.
 *
 * GHI LẠI MỘT CHẨN ĐOÁN SAI, để đừng lặp lại. Ngày 03/09 tôi thấy `currentTime`
 * chỉ nhích 0,44-0,50 giây sau 8 giây thực và kết luận "thiếu băng thông vì ba
 * clip 14,3 Mbps cần ~43 Mbps". Đo lại thì băng thông tới CDN là 39-117 Mbps,
 * thừa sức. Nguyên nhân thật: ba file gốc có `moov` nằm SAU `mdat`, không
 * faststart, nên trình duyệt phải tải gần hết 17MB mới tìm được chỉ mục để bắt
 * đầu phát. Bài học: gặp video "chạy mà không nhích" thì kiểm thứ tự atom
 * TRƯỚC khi đổ cho đường truyền.
 *
 * KHÁCH BẤM DỪNG THÌ PHẢI IM. Nếu chỉ nghe sự kiện `pause` rồi đánh dấu, phép
 * `pause()` của chính file này cũng bắn ra sự kiện đó và clip sẽ bị coi là
 * "khách đã dừng" ngay lần đầu cuộn qua. Cờ `__lbAuto` phân biệt hai nguồn: đặt
 * trước khi JS dừng, và chính handler xoá nó.
 *
 * Ảnh poster nằm ở thuộc tính `poster` trong markup, KHÔNG phải `#t=`. Lý do
 * dài nằm trong ghi chú của section `lb-video` — tóm tắt: `#t=` trỏ tới khung
 * cuối clip bắt trình duyệt seek tới ~90% của file 17MB rồi `loop` seek ngược
 * về đầu, và nó treo hẳn.
 */
(function () {
  'use strict';

  var VIDS = '.lb-demo .vids .vid';

  /* Phải lọt vào màn ít nhất chừng này mới được coi là ứng viên. Dưới ngưỡng thì
     không clip nào chạy — đúng ý: khách đang cuộn ngang qua, chưa dừng ở đâu. */
  var NGUONG = 0.4;

  function batDau() {
    var ds = Array.prototype.slice.call(document.querySelectorAll(VIDS));
    if (!ds.length) return;

    // Không có IntersectionObserver: để nguyên, khách bấm play. Thà không tự
    // chạy còn hơn tự chạy cả ba từ lúc tải trang.
    if (!('IntersectionObserver' in window)) return;

    var tyLe = new WeakMap();
    ds.forEach(function (v) { tyLe.set(v, 0); });

    function dung(v) {
      if (v.paused) return;
      v.__lbAuto = true;          // để handler `pause` biết không phải khách bấm
      v.pause();
    }

    function chay(v) {
      if (!v.paused || v.dataset.lbKhachDung) return;
      // play() trả về Promise và bị từ chối khi trình duyệt chặn phát tự động.
      // Nuốt lỗi: đã có ảnh poster nên vẫn nhìn ra là video gì.
      var hua = v.play();
      if (hua && hua.catch) hua.catch(function () {});
    }

    /* Chọn ĐÚNG MỘT clip: cái đang lọt vào màn nhiều nhất và vượt ngưỡng. Gọi
       sau mỗi lô sự kiện chứ không gọi trong vòng lặp từng phần tử — nếu không,
       clip xét sau sẽ dừng clip vừa được cho chạy. */
    function chon() {
      var thang = null, cao = NGUONG;
      ds.forEach(function (v) {
        var r = tyLe.get(v) || 0;
        // `>` chứ không `>=`: trên desktop ba clip nằm ngang hàng nên tỉ lệ lọt
        // vào màn gần bằng nhau, hoà liên tục. Với `>=` thì phần tử SAU thắng,
        // hoá ra clip thứ ba (General Lee) chạy — đo được đúng như vậy. Với `>`
        // thì phần tử ĐẦU giữ thế, tức KITT, khớp thứ tự đọc và thứ tự ba xe
        // dùng ở mọi nơi khác trên store.
        if (r > cao) { cao = r; thang = v; }
      });
      ds.forEach(function (v) { if (v !== thang) dung(v); });
      if (thang) chay(thang);
    }

    /* Nhiều mốc ngưỡng để nhận được cập nhật tỉ lệ liên tục khi khách cuộn. Chỉ
       một mốc thì observer chỉ báo lúc vượt qua đúng mốc đó, không đủ để so
       clip nào đang lọt vào màn nhiều hơn. */
    var theo = new IntersectionObserver(function (muc) {
      muc.forEach(function (m) { tyLe.set(m.target, m.intersectionRatio); });
      chon();
    }, { threshold: [0, 0.2, 0.4, 0.6, 0.8, 1] });

    ds.forEach(function (v) {
      v.addEventListener('pause', function () {
        if (v.__lbAuto) { v.__lbAuto = false; return; }  // do file này dừng
        v.dataset.lbKhachDung = '1';                     // khách tự bấm dừng
      });
      v.addEventListener('play', function () {
        delete v.dataset.lbKhachDung;
        // Khách tự bấm play một clip: các clip khác phải nhường băng thông.
        ds.forEach(function (k) { if (k !== v) dung(k); });
      });
      theo.observe(v);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', batDau);
  } else {
    batDau();
  }
})();
